import { Component, HostListener, Injector } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SecurityDataService } from '../../angular-common/security-data.service';

@Component({
  templateUrl: './cookie-policy-dialog.component.html'
})
export class CookiePolicyDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<CookiePolicyDialogComponent>,
    protected _injector: Injector) {}

  @HostListener('document:click', ['$event'])
  private onClick(event) {
    if(event.target.className.split(' ').includes('goToInformativaGdpr'))  
      this.goToInformativaGdpr()
    else if(event.target.className.split(' ').includes('goToPywik'))  
      this.goToPywik()
    else if(event.target.className.split(' ').includes('revokeCookiePolicyConsent'))  
      this.revokeCookiePolicyConsent()
  }

  async goToInformativaGdpr(){
    window.open('https://www.lavoro.gov.it/Documents/informativa_GDPR.pdf', "_blank");
  }

  async goToPywik(){
    window.open('https://matomo.org/privacy-policy/', "_blank");
  }

  revokeCookiePolicyConsent(){
    this._injector.get(SecurityDataService).revokeCookiePolicyConsent();
    this._injector.get(Router).navigate(['/home']);
  }
}
